import { CAT_INFO_REQUESTS } from 'App/utils/Collections';
import { FT_AUTOCOMPLETE, FT_LIST, FT_DATE, FT_SINGLE } from '../FilterTypes';

import { searchCustomers, statusItemsLoader } from './loaders';

const groups = {
  general: {
    name: 'General',
    groupOrderIndex: 0,
  },
  tracking: {
    name: 'Tracking',
    groupOrderIndex: 1,
  },
  date: {
    name: 'Date',
    groupOrderIndex: 2,
  },
};

export default {
  category: CAT_INFO_REQUESTS,
  filters: [
    {
      id: 'dealItems.item.name',
      label: 'Product/Company name',
      type: FT_SINGLE,
      group: groups.general,
    },
    {
      id: 'status.id',
      label: 'Status',
      type: FT_LIST,
      group: groups.general,
      getListItems: () => statusItemsLoader(21),
    },
    {
      id: 'customer.id',
      label: 'Customer',
      type: FT_AUTOCOMPLETE,
      group: groups.general,
      fieldConf: {
        searcher: searchCustomers,
      },
    },
    {
      id: 'createdAt',
      label: 'Created at',
      group: groups.date,
      type: FT_DATE,
    },
  ],
  searchBarProp: 'complex_name',
};
